var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',[_c('v-btn',{style:({ 'text-transform': 'none' }),attrs:{"color":"error","loading":_vm.isLoading},on:{"click":_vm.callSaveChanges}},[_vm._v("\n    "+_vm._s(_vm.lang.delete)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }